import React from 'react';
import Seo from './seo';

const meta = [
    {
        name: 'keywords',
        content: '9up, 라인업, 나인업, 컬렉터블, 프로야구, kbo, 한국야구, 야구게임, 야구카드, 시뮬레이션, 스포츠, 야구, 매니지먼트, 매니징, 야구응원가, kbo프로야구, 비더레전드, 컴프야, 컴프매, 넷프야, 마구마구'
    },
    {
        property: 'og:site_name',
        content: '9UP 프로야구'
    },
    {
        property: 'og:keywords',
        content: '9UP 프로야구'
    },
    {
        property: 'og:url',
        content: process.env.GATSBY_PAGE_URL
    },
    {
        property: 'image',
        content: `${process.env.GATSBY_PAGE_URL}/thumbnail.jpg`
    },
    {
        property: 'og:image',
        content: `${process.env.GATSBY_PAGE_URL}/thumbnail.jpg`
    },
    {
        property: 'og:image:width',
        content: '1200'
    },
    {
        property: 'og:image:height',
        content: '630'
    }
];

const Component = () => (
    <Seo title="9UP 프로야구"
        description="진정한 야덕을 위한 KBO 덕질 플랫폼, 9UP 프로야구!"
        meta={meta}
    />
);

export default Component;